module.exports = __webpack_public_path__ + "static/media/phone.cc902c1a.svg";